import { useAuth } from "@/contexts/AuthContext";
import { format } from "date-fns";

export default function Profile() {
  const { user } = useAuth();
  return (
    <div className="max-w-2xl space-y-6">
      <header>
        <div className="font-mono text-[10px] tracking-widest uppercase text-primary mb-2">// Account</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Profile</h1>
      </header>
      <div className="p-6 rounded-lg border border-border/60 bg-card space-y-4">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-secondary flex items-center justify-center font-display font-black text-2xl">
            {(user?.name || user?.email || "?").slice(0,1).toUpperCase()}
          </div>
          <div>
            <div className="font-display font-bold text-xl">{user?.name}</div>
            <div className="text-sm text-muted-foreground">{user?.email}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border/60">
          <Meta k="Role" v={user?.role} />
          <Meta k="Provider" v={user?.provider || "local"} />
          <Meta k="User ID" v={<span className="font-mono text-[11px]">{user?.user_id}</span>} />
          {user?.created_at && <Meta k="Joined" v={format(new Date(user.created_at), "PP")} />}
        </div>
      </div>
    </div>
  );
}

function Meta({ k, v }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{k}</div>
      <div className="text-sm mt-1">{v}</div>
    </div>
  );
}
